// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2CkSm","subheader":"ReorderModal_subheader__3O9MY","listWrap":"ReorderModal_listWrap__15M6W"};